<div class="family-brand-container">
  <h3 class="family-brand-header">
    {{ header }}
  </h3>

  <div class="family-brand-blocks-wrapper">
    <div *ngFor="let block of familyBlocks" class="family-brand-block">
      <div class="family-brand-block-image">
        <jb-image [src]="block.image.src" [alt]="block.image.alt"></jb-image>
      </div>
      <div>
        <a
          jbActionLink
          id="action-link-text-cta-links-default"
          [target]="block.link.target"
          class="no-underline hover-core-blue royal-blue b"
          [href]="block.link.href"
        >
          {{ block.label }}
          <jb-icon
            class="pl1"
            [name]="
              block?.link?.isExternalLink ? 'externalLink' : 'rightFilled'
            "
            label="navigates to external page"
          ></jb-icon>
        </a>
      </div>
    </div>
  </div>
</div>
